module.exports = __webpack_public_path__ + "img/bronzemedal.f145701f.png";